import React, { memo, useState, useEffect } from "react";
import {
  ProgressBarHeader,
  ProgressBarBar,
  ProgressBarMoving,
  ProgressBarContainer,
} from "./ProgressBarStyles";
import { useTranslation } from "../../../locale/context";

const ProgressBar = ({ state }: any) => {
  const [isAnimationVisible, setIsAnimationVisible] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    state === 1 && handleVisibilityChange();
  }, [state]);

  const handleVisibilityChange = () => {
    if (!document.hidden) {
      setIsAnimationVisible(true);
    } else {
      setIsAnimationVisible(false);
    }
  };

  return (
    <ProgressBarContainer isVisible={isAnimationVisible}>
      <ProgressBarHeader>{t("common.gameState.nextRound")}</ProgressBarHeader>
      <ProgressBarBar>
        <ProgressBarMoving elapsed={isAnimationVisible}></ProgressBarMoving>
      </ProgressBarBar>
    </ProgressBarContainer>
  );
};

export default memo(ProgressBar);
